<template>
    <v-layout column fill-height>
        <breadcrumbs titulo="Configurações" descricao="Atualização de senha" />

        <v-layout class="main full">
            <v-flex>
                <v-layout row class="content-body overflow-y-auto">
                  <Configuracao />
                </v-layout>
            </v-flex>
        </v-layout>

    </v-layout>
</template>


<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import Configuracao from "@/components/portal/configuracoes/Configuracao";

export default {
  components: {
    breadcrumbs,
    Configuracao
  },
  data() {
    return {
        guia: "Configurações"
    }
  },
  methods: {
 }
};
</script>